import { RootEntityType } from '@schooly/api';
import { useUserNotifications } from '@schooly/context';
import { useMemo } from 'react';

type UseThreadUnreadProps = {
  rootEntityType: RootEntityType;
  rootEntityId: string;
};

export const useThreadUnread = ({ rootEntityType, rootEntityId }: UseThreadUnreadProps) => {
  const { threadsUnread } = useUserNotifications();

  return useMemo(() => {
    return threadsUnread?.unread_threads[rootEntityType]?.[rootEntityId]?.some(
      (d) => d.unread_count > 0,
    );
  }, [threadsUnread, rootEntityId, rootEntityType]);
};
